/**
 * @generated SignedSource<<32bd8fb71ad4d0ffe41e1b609d9bd6ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type packageIsAvailableForSale_package$data = {
  readonly displayInApp: {
    readonly availableFrom: string;
    readonly availableTo: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "packageIsAvailableForSale_package";
};
export type packageIsAvailableForSale_package$key = {
  readonly " $data"?: packageIsAvailableForSale_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"packageIsAvailableForSale_package">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "packageIsAvailableForSale_package"
};

(node as any).hash = "9780e34fc08a5574d1423994dc2d0de0";

export default node;
